module.exports = __webpack_public_path__ + "img/第7章_2-1_名片與簽名.jpg";